import { keysToSnakeCase } from '@shared/utils/utils';
import request from '@shared/api/request';
import {
    DefectFormValues,
    DefectsMultipleActionParams,
    DefectsRequestParams,
    EditDefectParams,
    GetDefectParams,
    JiraIssuesRequestParams,
} from '../types';
import { API_DEFECTS_PATH } from '@shared/constants/pathsConstants';

export function getDefects(params: DefectsRequestParams) {
    return request.get(`/${API_DEFECTS_PATH}/`, { params });
}

export function deleteDefects(params: DefectsMultipleActionParams) {
    return request.post(`/${API_DEFECTS_PATH}/delete/`, params);
}

export function closeDefects(params: DefectsMultipleActionParams) {
    return request.post(`/${API_DEFECTS_PATH}/update/`, params);
}

export function addDefect(params: DefectFormValues) {
    const { jiraIssue, ...restParams } = params;
    return request.post(`/${API_DEFECTS_PATH}/`, keysToSnakeCase(restParams));
}

export function getDefect(params: GetDefectParams) {
    return request.get(`/${API_DEFECTS_PATH}/${params.defectId}/`);
}

export function deleteDefect(params: GetDefectParams) {
    return request.delete(`/${API_DEFECTS_PATH}/${params.defectId}/`);
}

export function editDefect(params: EditDefectParams) {
    const { jiraIssue, ...restParams } = params;
    return request.patch(
        `/${API_DEFECTS_PATH}/${params.pk}/`,
        keysToSnakeCase({ jiraIssueKey: jiraIssue?.key, jiraIssueUrl: jiraIssue?.jiraLink, ...restParams }),
    );
}

export const getJiraIssues = (params: JiraIssuesRequestParams) => {
    return request.get(`/${API_DEFECTS_PATH}/jira-tasks/`, { params });
};
